module.exports = __webpack_public_path__ + "img/handball.7fef1584.svg";